import React from 'react';
import BCPriceTable from '../result/bestcombination/pricetable/BCPriceTable';
import { useStreamingProviders } from '../shared/hooks/useStreamingProvider';
import { StyledTypo } from '../overviewandfilter/styled/OverviewAndFilter.styled';
import { StyledBox } from '../home/Home.styled';
import Loader from '../shared/loader/Loader';
import ErrorSnackbar from '../shared/snackbar/ErrorSnackbar';

const ProviderPrices: React.FC = () => {
  const { providers, loading, error } = useStreamingProviders();

  if (error)
    return <ErrorSnackbar customError="Error loading Provider prices" open />;
  return (
    <StyledBox>
      <StyledTypo
        variant="h4"
        align="left"
        fontWeight="bold"
        fontStyle="italic"
      >
        Provider prices
      </StyledTypo>
      {loading ? (
        <Loader />
      ) : (
        <BCPriceTable
          providers={providers}
          isShowCheapeastActive={false}
          showSorted
          showWithIcons
        />
      )}
    </StyledBox>
  );
};
export default ProviderPrices;
